import { useAppLocale } from '../../lib/i18n/AppI18nProvider';
import {
    loadGeneratedLegalDocuments,
    type GeneratedLegalLocale,
} from './generated';
import type { LegalDocument } from './types';

export function useLocalizedLegalDocument(documentId: string): LegalDocument {
    const { messageLocale } = useAppLocale();
    const contentLocale = messageLocale === 'en-XA' ? 'en' : messageLocale;
    const documents = loadGeneratedLegalDocuments(contentLocale as GeneratedLegalLocale);
    const document = documents[documentId] ?? loadGeneratedLegalDocuments('en')[documentId];
    if (!document) {
        throw new Error(`Missing localized legal document: ${contentLocale}/${documentId}`);
    }
    return document;
}
